const Benefits = ({ BenefitsInfo }) => {
  return (
    <div className="bg-[#F2F2F2]">
      <div className="custom-container py-[40px] sm:py-[87px]">
        <div className="font-[Rockwell] 2xl:text-[45px] xl:text-[40px] lg:text-[35px] md:text-[30px] sm:text-[25px] text-[18px] font-extrabold border-b-[2px] sm:border-b-[3px] border-[#7ABF5B] text-[#000]">
          BENEFITS
        </div>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 sm:gap-16 mt-[30px] sm:mt-[43px]">
          {BenefitsInfo?.map((item) => {
            return (
              <div>
                <div className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
                  {item?.title}
                </div>
                <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] mt-[25px]">
                  {item?.subTitle}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default Benefits;
